import React from 'react'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import PageHeading from '../../components/pageHeading/PageHeading'
import { CheckMarkIcon } from '../../components/Icons'
import { useEffect, useState } from 'react';
import { getContent, getAllContent } from '../../services/auth.service';
import Loader from '../../components/Loader/Loader'
import { setLoader } from '../../slice/commonSlice'
import { useDispatch } from 'react-redux'
function CookiePolicy() {
    const [contentId,setContentId]=useState();
    const [content,setContent]=useState();
    const dispatch = useDispatch();

    const getallcontent = async () => {
        try{
            await dispatch(setLoader(true));
            const result = await getAllContent();
            if (result?.status === 200) {
            const searchObject = result.data.find((data) => data.slug == "cookiePolicy");
                setContentId(searchObject._id)
                await dispatch(setLoader(false));
            }else{
                await dispatch(setLoader(false));
            }

        }catch(e){
            await dispatch(setLoader(false));
        }
    }

    const getcontent = async () => {
        try{
            await dispatch(setLoader(true));
            const paylaod = { "_id": contentId }
            const result = await getContent(paylaod);
            if (result?.status === 200) {
                setContent(result.data.content)
                await dispatch(setLoader(false));
              } else {
                await dispatch(setLoader(false));
              }
            } catch (e) {
              await dispatch(setLoader(false));
            }
    }

    useEffect(() => {
        getallcontent()
    }, [])
    useEffect(() => {
        getcontent()
    }, [contentId])
  return (
   <>
    <Header />
            <PageHeading title="Cookie Policy" />
            {/* <Loader/> */}
            <div className='main-container'>
                <div className='container-wrap'>
                    <div className='inner-page-content'>
                        {/* <div className='page-content'>
                            <h4>What is Lorem Ipsum?</h4>
                            <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
                        </div>
                        <div className='page-content'>
                            <h4>What is Lorem Ipsum?</h4>
                            <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
                            <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
                        </div>
                        <div className='page-content'>
                            <h4>What is Lorem Ipsum?</h4>
                            <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
                            <ul>
                                <li><i><CheckMarkIcon /></i> It is a long established fact that a reader will be distracted by the readable content.</li>
                                <li><i><CheckMarkIcon /></i> It is a long established fact that a reader will be distracted by the readable content.</li>
                                <li><i><CheckMarkIcon /></i> It is a long established fact that a reader will be distracted by the readable content.</li>
                                <li><i><CheckMarkIcon /></i> It is a long established fact that a reader will be distracted by the readable content.</li>
                                <li><i><CheckMarkIcon /></i> It is a long established fact that a reader will be distracted by the readable content.</li>
                            </ul>
                            <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.</p>
                        </div> */}
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                    </div>
                </div>
            </div>
            <Footer />
   </>
  )
}

export default CookiePolicy
